console.log('[Zapiet Custom Lead Time] File loaded');

(function () {
  const TARGET_PRODUCT_IDS = [
    7736287428675,
    7736287723587,
    7736288051267,
    7736288215107
  ];

  let currentLeadDays = 0;
  let currentEarliestDate = null;
  let refreshTimer = null;

  function getLeadDays(qty) {
  const now = new Date();
  const isAfter4PM = now.getHours() >= 16;

  if (qty >= 1 && qty <= 30) return 1;

  if (qty >= 31 && qty <= 34) return 3;

  if (qty >= 35 && qty <= 50) {
    return isAfter4PM ? 4 : 3;
  }

  return 0;
}


  function getDateFromAriaLabel(label) {
    const date = new Date(label);
    if (isNaN(date.getTime())) return null;
    date.setHours(0, 0, 0, 0);
    return date;
  }

  function resetZapietDates() {
    document.querySelectorAll('.Zapiet-Calendar__Date.picker__day').forEach(function (button) {
      button.classList.remove('Zapiet-Calendar__Date--disabled', 'picker__day--disabled');
      button.removeAttribute('disabled');
      button.setAttribute('aria-disabled', 'false');
      button.style.pointerEvents = '';
      button.style.opacity = '';
      button.style.cursor = '';
    });
  }

  function disableDatesBefore(earliestDate) {
    resetZapietDates();

    document.querySelectorAll('.Zapiet-Calendar__Date.picker__day').forEach(function (button) {
      const buttonDate = getDateFromAriaLabel(button.getAttribute('aria-label'));
      if (!buttonDate) return;

      if (buttonDate < earliestDate) {
        button.classList.add('Zapiet-Calendar__Date--disabled', 'picker__day--disabled');
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('disabled', 'disabled');
        button.style.pointerEvents = 'none';
        button.style.opacity = '0.25';
        button.style.cursor = 'not-allowed';
      }
    });
  }

  async function calculateLeadTime() {
    const cart = await fetch('/cart.js').then(res => res.json());

    let qty = 0;

    cart.items.forEach(function (item) {
      if (TARGET_PRODUCT_IDS.includes(Number(item.product_id))) {
        qty += item.quantity;
      }
    });

    currentLeadDays = getLeadDays(qty);

    currentEarliestDate = new Date();
    currentEarliestDate.setDate(currentEarliestDate.getDate() + currentLeadDays);
    currentEarliestDate.setHours(0, 0, 0, 0);

    console.log('[Zapiet Custom Lead Time] Qty:', qty);
    console.log('[Zapiet Custom Lead Time] Lead days:', currentLeadDays);

    if (currentLeadDays > 0) {
      disableDatesBefore(currentEarliestDate);
    }
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(calculateLeadTime, 700);
  }

  document.addEventListener('click', function (event) {
    if (
      event.target.closest('button') ||
      event.target.closest('[name="updates[]"]') ||
      event.target.closest('.quantity') ||
      event.target.closest('.quantity__button')
    ) {
      scheduleRefresh();
    }

    if (currentEarliestDate) {
      setTimeout(() => disableDatesBefore(currentEarliestDate), 300);
      setTimeout(() => disableDatesBefore(currentEarliestDate), 800);
    }
  });

  document.addEventListener('change', function (event) {
    if (
      event.target.matches('[name="updates[]"]') ||
      event.target.matches('input[type="number"]')
    ) {
      scheduleRefresh();
    }
  });

  const observer = new MutationObserver(function () {
    if (currentEarliestDate) {
      disableDatesBefore(currentEarliestDate);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', calculateLeadTime);
  } else {
    calculateLeadTime();
  }
})();